import { render, staticRenderFns } from "./ChangelogOverview.vue?vue&type=template&id=68181675&scoped=true&"
import script from "./ChangelogOverview.vue?vue&type=script&lang=js&"
export * from "./ChangelogOverview.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogOverview.vue?vue&type=style&index=0&id=68181675&lang=stylus&scoped=true&"
import style1 from "./ChangelogOverview.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68181675",
  null
  
)

export default component.exports